<script lang="ts">
export default {
  name: 'QuickLogin',
  inheritAttrs: false,
  customOptions: {}
}
</script>

<script setup lang="ts">
import LoginTest from "../components/LoginTest.vue";
import {ref, watch} from "vue";

const props = defineProps({
  verify_email_url: { type: String, required: true },
  login_url: { type: String, required: true },
  forgot_password_url: { type: String, default: '' },
  callback: { type: Function, required: true },
  trans: { type: Object, required: true },
});

const login_test_step = ref('verify_email');
watch(login_test_step, (_new) => {
  if (_new === 'success') {
    props.callback();
  } else if (_new === 'register') {
    // do nothing
  }
});
</script>

<template>
  <form class="form required-labels">
    <LoginTest v-model:step="login_test_step" :verify_email_url="verify_email_url" :login_url="login_url" :forgot_password_url="forgot_password_url" :trans="trans"></LoginTest>

    <div class="notice notice-error" v-if="login_test_step === 'register'">
      {{ trans.register }}
    </div>
  </form>
</template>